import {
  GenericNotificationChannels,
  OrganizationRaw,
  OrganizationsItemRaw,
} from "../../domain/Organization";
import { API_CLIENT } from "../config";
import { getAPIConfigs } from "../helpers";

const apiUrlOrganizations = "/organizations";
const apiUrlGenericNotificationChannels = "/generic_notification_channels";
const apiUrlInivitaionsOrganizations = "/invitations" + apiUrlOrganizations;

export const getOrganization = async ({
  organizationId,
}: {
  organizationId: OrganizationRaw["org_id"];
}): Promise<OrganizationRaw> => {
  const response = await API_CLIENT.get<{ item: OrganizationRaw }>(
    `${apiUrlOrganizations}/${organizationId}`,
    {}
  );
  return response.data.item;
};
export const getOrganizations = async (): Promise<OrganizationsItemRaw[]> => {
  const response = await API_CLIENT.get<{ items: OrganizationsItemRaw[] }>(
    `${apiUrlOrganizations}`
  );
  return response.data.items;
};
export const postEditOrganization = async ({
  organizationId,
  organizationRawForm,
}: {
  organizationId: OrganizationRaw["org_id"];
  organizationRawForm: OrganizationRaw;
}): Promise<OrganizationRaw> => {
  const { apiHeadersWithJson } = getAPIConfigs();
  const response = await API_CLIENT.post<{ item: OrganizationRaw }>(
    `${apiUrlOrganizations}/${organizationId}`,
    organizationRawForm,
    {
      ...apiHeadersWithJson,
    }
  );
  return response.data.item;
};
export const postCreateOrganization = async ({
  organizationRawForm,
}: {
  organizationRawForm: OrganizationRaw;
}): Promise<OrganizationRaw> => {
  const { apiHeadersWithJson } = getAPIConfigs();
  const response = await API_CLIENT.post<{ item: OrganizationRaw }>(
    `${apiUrlOrganizations}`,
    organizationRawForm,
    {
      ...apiHeadersWithJson,
    }
  );
  return response.data.item;
};

export const postEditIsMfaOrganization = async ({
  organizationId,
  is_mfa_required,
}: {
  organizationId: OrganizationRaw["org_id"];
  is_mfa_required: OrganizationRaw["is_mfa_required"];
}): Promise<OrganizationRaw> => {
  const { apiHeadersWithJson } = getAPIConfigs();
  const response = await API_CLIENT.post<{ item: OrganizationRaw }>(
    `${apiUrlOrganizations}/${organizationId}/is_mfa_required`,
    { is_mfa_required },
    {
      ...apiHeadersWithJson,
    }
  );
  return response.data.item;
};

// 組織の「標準ヘッダー・サイドメニューの表示」(is_sidebar_enabled) 専用更新エンドポイント。
// is_mfa_required と同様、組織管理者 (OrganizationsWrite) が組織設定 > 機能タブから操作する。
export const postEditIsSidebarEnabledOrganization = async ({
  organizationId,
  is_sidebar_enabled,
}: {
  organizationId: OrganizationRaw["org_id"];
  is_sidebar_enabled: boolean;
}): Promise<OrganizationRaw> => {
  const { apiHeadersWithJson } = getAPIConfigs();
  const response = await API_CLIENT.post<{ item: OrganizationRaw }>(
    `${apiUrlOrganizations}/${organizationId}/is_sidebar_enabled`,
    { is_sidebar_enabled },
    {
      ...apiHeadersWithJson,
    }
  );
  return response.data.item;
};

// 組織の「組織トップページ」(initial_extra_page_id) 専用更新エンドポイント。
// is_sidebar_enabled と同様、表示設定の編集権限 (organizations_display_setting:write) を持つユーザーが組織設定 > 機能から操作する。
// 未設定に戻す場合は空文字を送る。
export const postEditInitialExtraPageIdOrganization = async ({
  organizationId,
  initial_extra_page_id,
}: {
  organizationId: OrganizationRaw["org_id"];
  initial_extra_page_id: string;
}): Promise<OrganizationRaw> => {
  const { apiHeadersWithJson } = getAPIConfigs();
  const response = await API_CLIENT.post<{ item: OrganizationRaw }>(
    `${apiUrlOrganizations}/${organizationId}/initial_extra_page_id`,
    { initial_extra_page_id },
    {
      ...apiHeadersWithJson,
    }
  );
  return response.data.item;
};

export const getGenericNotificationChannel = async ({
  organizationId,
}: {
  organizationId: OrganizationRaw["org_id"];
}): Promise<GenericNotificationChannels | null> => {
  const response = await API_CLIENT.get<{
    item: GenericNotificationChannels | null;
  }>(`${apiUrlGenericNotificationChannels}/${organizationId}`);
  return response.data.item;
};

export const postEditGenericNotificationChannel = async ({
  organizationId,
  generic_notification_channel,
}: {
  organizationId: OrganizationRaw["org_id"];
  generic_notification_channel: GenericNotificationChannels;
}): Promise<void> => {
  const { apiHeadersWithJson } = getAPIConfigs();
  await API_CLIENT.post<void>(
    `${apiUrlGenericNotificationChannels}/${organizationId}`,
    { ...generic_notification_channel },
    {
      ...apiHeadersWithJson,
    }
  );
};

export const getInvitationsOrganizations = async (): Promise<
  OrganizationsItemRaw[]
> => {
  const response = await API_CLIENT.get(`${apiUrlInivitaionsOrganizations}`);
  return response.data.items;
};
export const postAcceptIvitationOrganization = async ({
  organizationId,
  is_accept,
}: {
  organizationId: OrganizationRaw["org_id"];
  is_accept: boolean;
}): Promise<OrganizationsItemRaw> => {
  const { apiHeadersWithJson } = getAPIConfigs(organizationId);
  const response = await API_CLIENT.post<{ item: OrganizationsItemRaw }>(
    `${apiUrlInivitaionsOrganizations}/${organizationId}`,
    { is_accept },
    {
      ...apiHeadersWithJson,
    }
  );
  return response.data.item;
};
